import { Dispatch } from "redux";
import RewardShipmentService from "service/RewardShipment";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import { RewardShipmentPayloadTypes } from "utilities/types/RewardShipment";
import { RewardShipmentDetailPayloadTypes } from "utilities/types/RewardShipmentDetail";

export const getAllRewardShipments =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterTenant: number = 3
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_REWARD_SHIPMENT_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_REWARD_SHIPMENT",
      searchValue: search,
    });

    try {
      const data = await RewardShipmentService.getAllRewardShipments(
        page,
        search,
        limit,
        filterTenant
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_REWARD_SHIPMENT", value: data.catalog_shipments });
      dispatch({
        type: "SET_REWARD_SHIPMENT_PAGE",
        totalPage: !!data.catalog_shipments.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.catalog_shipments.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_REWARD_SHIPMENT_FILTER_PAGE",
        filterTenantPage: filterTenant,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getRewardShipmentById =
  (catalogShipmentId: any) => async (dispatch: Dispatch) => {
    dispatch({ type: "SET_REWARD_SHIPMENT_DETAIL_LOADING", value: true });

    try {
      const data = await RewardShipmentService.getRewardShipmentById(
        catalogShipmentId
      );
      dispatch({ type: "SET_REWARD_SHIPMENT_DETAIL_LOADING", value: false });

      dispatch({
        type: "SET_REWARD_SHIPMENT_DETAIL",
        value: data.catalog_shipment.details,
      });
      dispatch({
        type: "SET_REWARD_SHIPMENT_USER_CATALOG",
        value: data.catalog_shipment.user_catalogs,
      });
    } catch (err: any) {
      dispatch({ type: "SET_REWARD_SHIPMENT_DETAIL_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const updateRewardShipment =
  (
    rewardShipmentId: string,
    form: RewardShipmentPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await RewardShipmentService.updateRewardShipment(
        rewardShipmentId,
        payload
      );
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().rewardShipmentReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllRewardShipments(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const storeRewardShipmentDetail =
  (
    rewardShipmentId: string,
    form: RewardShipmentDetailPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await RewardShipmentService.storeRewardShipmentDetail(
        rewardShipmentId,
        payload
      );

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getRewardShipmentById(rewardShipmentId) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
